import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { WhatsAppConfigService } from 'src/app/private/services/whatsappconfig.service';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-delete-whatsapp-config',
  imports: [SharedModule],
  templateUrl: './delete-whatsapp-config.component.html',
  styleUrl: './delete-whatsapp-config.component.scss'
})
export class DeleteWhatsappConfigComponent {
 @Input() whatsappConfigDataToEdit: any = null;
  @Input() clientId: string = '';
  isLoading = false;

  @Output() close = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();

  constructor(
    private whatsappConfigService: WhatsAppConfigService,
    private messageService: MessageService
  ) {}

  handleCloseDialog() {
    this.close.emit();
  }

  handleDeleteConfig() {
    if (!this.whatsappConfigDataToEdit?.id) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Invalid WhatsApp configuration selected'
      });
      return;
    }

    this.isLoading = true;
    const payload = {
      id: this.whatsappConfigDataToEdit.id,
      client_id: this.clientId // Ensure client_id is set from input
    };

    this.whatsappConfigService.deleteWhatsAppConfig(payload).subscribe({
      next: () => {
        this.isLoading = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'WhatsApp configuration deleted successfully'
        });
        this.reload.emit();
        this.close.emit();
      },
      error: (err) => {
        this.isLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: err.error?.message || 'An error occurred while deleting the WhatsApp configuration'
        });
      }
    });
  }
}
